import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { useLanguage } from '../includes/LanguageContext.js'; // Importing Language Context

const Footer = ({ company }) => {
    const { currentLanguage, selectedLanguage, setSelectedLanguage } = useLanguage();
//console.log(company);
    return (
        <footer className="footer-section">
            <div className="container">
                <div className="row">
                    <div className="col-md-3">
                        <div className="footer-content">
                            <h3>{currentLanguage.footer.about} :</h3>
                            <p>{currentLanguage.footer.aboutDesc}</p>
                        </div>
                    </div>
                    
                    <div className="col-md-3">
                        <div className="footer-content">
                            <h3>{currentLanguage.footer.links} :</h3>
                            <ul className="footer-links">
                                <li><Link to="/">{currentLanguage.menu.home}</Link></li>
                                <li><Link to="/about">About Us</Link></li>
                                <li><Link to="/category">Category</Link></li>
                                <li><Link to="/contact">{currentLanguage.menu.contact}</Link></li>
                                <li><Link to="/policy">Policy</Link></li>
                            </ul>
                        </div>
                    </div>
                    
                    <div className="col-md-3">
                        <div className="footer-content">
                            <h3>{currentLanguage.footer.contact}</h3>
                            <ul className="footer-contact">
                                <li>
                                    <i className="bi bi-envelope"></i>
                                    <a href="mailto:kahanifm1@gmail.com">{company.email}</a>
                                </li>
                                <li>
                                    <i className="bi bi-geo-alt"></i>
                                    <p>{company.address}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                    <div className="col-md-3">
                        <div className="footer-content">
                            <h3>{currentLanguage.footer.media}</h3>
                            <div className="social-links">
                                <a href="https://www.instagram.com/kahanifm_?utm_source=qr&igsh=MWg5aWlvMDh5dzJhOA==" className="instagram"><i className="bi bi-instagram"></i></a>
                                <a href="#" className="youtube"><i className="bi bi-youtube"></i></a>
                                <a href="#" className="facebook"><i className="bi bi-facebook"></i></a>
                                <a href="#" className="twitter"><i className="bi bi-twitter-x"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="container">
                    <div className="copyright">
                        © 2025 {company.company_title}. All Rights Reserved.
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;